<template>
  <!-- MOBILE -->
  <div
  v-if="$vuetify.breakpoint.xs"
  v-ripple
  :class="['c-flex-r mrow', {'selected-row': selected[item.tempID]}]">

    <v-btn
    icon
    text
    @click.stop="$emit('checkRow', item)">
      <v-icon :color="selected[item.id] ? 'color1' : ''"> 
        {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
      </v-icon>
    </v-btn>

    <transition
    name="slide-x-transition"
    appear
    hide-on-leave
    mode="out-in">
      <v-icon v-if="itemsMeta.newID === item.id" color="color1" style="position: absolute; left: 0px; top: 0px;">mdi-new-box</v-icon>
    </transition>

    <img class="c-align-self-start" src="@/assets/img/illustrations/production.png" alt="cardboard box" width="65px">

    <div class="c-flex-c1 ml-1">
      <v-layout>
        <v-flex>
          <div :class="['caption']">
            <span>
              Production ID: {{ production.id }}
            </span>
          </div>
          <div class="mt-2 mb-2">

            <output-row
            v-if="mainOutput"
            :selected="{}"
            :item="mainOutput"
            :vmode="3">
            </output-row>
            <div v-else class="font-weight-medium">
              No outputs!
            </div>

            <output-row
            v-for="output in secondaryOutputs" 
            :key="output.id"
            :selected="{}"
            :item="output"
            :vmode="3">
            </output-row>       

          </div>
          <div :class="['mt-1 caption']">
            <div v-if="timelineStage === 2">
              Completed: 
              <span>
                {{ dateEndFromNow }}
              </span>,
              <span class="caption text--text text--darken-1">
                {{ dateEndFormatted }}
              </span>
            </div>
            <div v-if="timelineStage === 1">
              Started: 
              <span class="blue--text">
                {{ dateStartFromNow }}
              </span>,
              <span class="caption text--text text--darken-1">
                {{ dateStartFormatted }}
              </span>
            </div>
          </div>

        </v-flex>
      </v-layout>
      
    </div>

  </div>

  <!-- PC -->
  <v-card v-else outlined :class="['mrow ma-2 mb-4 mt-4', {'selected': selected[item.id]}]">
    <v-row class="align-center border-b--thin pa-2 pl-4">
      <v-btn
      icon
      text
      @click.stop="$emit('checkRow', item)">
        <v-icon :color="selected[item.id] ? 'color1' : ''"> 
          {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
        </v-icon>
      </v-btn>
      <transition
      name="slide-x-transition"
      appear
      hide-on-leave
      mode="out-in">
        <v-icon v-if="itemsMeta.newID === item.id" color="color1" style="position: absolute; left: 0px; top: 0px;">mdi-new-box</v-icon>
      </transition>

      <text-highlight style="white-space: initial;" :queries="searchFilters.id + ''" highlightClass="white--text color1" highlightStyle="">{{ item.id }}</text-highlight>

      <v-spacer></v-spacer>

      <div class="text-right">
        <div :class="['text-ellipsed']">
        {{ dateEndFromNow }}
        </div>
        <div class="textSecondary--text caption">
          {{ dateEndFormatted }}
        </div>
      </div>

    </v-row>
    <div class="pa-2">
      <v-chip outlined v-if="false">
        <v-icon small :color="outputs.length !== 0 ? 'color1' : 'grey'">mdi-comment-eye-outline</v-icon>
        <span :class="['caption', outputs.length !== 0 ? 'color1--text' : 'grey--text']">
          {{ outputs.length }}
        </span>
      </v-chip>
      <output-row
      v-if="mainOutput"
      :selected="{}"
      :item="mainOutput"
      :vmode="3">
      </output-row>
      <div v-else class="label caption">
        No outputs.
      </div>

      <output-row
      v-for="output in secondaryOutputs" 
      :key="output.id"
      :selected="{}"
      :item="output"
      :vmode="3">
      </output-row>
    </div>
  </v-card>

  <!--
  <tr v-else
  :class="{'selected': selected[item.id]}">
    <td class="sticky">
      <v-layout align-center>

        <v-menu v-if="$store.state.settings.debugMode" offset-x open-on-hover :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            color="red"
            v-on="on"
          >
            <v-icon small>mdi-android-debug-bridge</v-icon>
          </v-btn>
        </template>
        <v-card outlined class="elevation-0">
          <v-layout class="backgroundCard pa-2 caption">
            JSON
          </v-layout>
          <div class="c-hr"></div>
          <div class="pa-3">
            <span class="caption">
              {{ item }}
              <json-viewer :item="item"></json-viewer>
            </span>
          </div>
        </v-card>
      </v-menu>

        <v-btn
        icon
        text
        @click.stop="$emit('checkRow', item)">
          <v-icon :color="selected[item.id] ? 'color1' : ''"> 
            {{ selected[item.id] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>
        <transition
        name="slide-x-transition"
        appear
        hide-on-leave
        mode="out-in">
          <v-icon v-if="itemsMeta.newID === item.id" color="color1" style="position: absolute; left: 0px; top: 0px;">mdi-new-box</v-icon>
        </transition>

        <v-avatar tile size="36" class="mr-2">
          <img class="" src="@/assets/img/illustrations/production.png" alt="cardboard box">
        </v-avatar>

        <v-layout column>
          <text-highlight style="white-space: initial;" :queries="searchFilters.id + ''" highlightClass="white--text color1" highlightStyle="">{{ item.id }}</text-highlight>
        </v-layout>
      </v-layout>
    </td>
    <td>
      <v-chip outlined v-if="false">
        <v-icon small :color="outputs.length !== 0 ? 'color1' : 'grey'">mdi-comment-eye-outline</v-icon>
        <span :class="['caption', outputs.length !== 0 ? 'color1--text' : 'grey--text']">
          {{ outputs.length }}
        </span>
      </v-chip>
      <output-row
      v-if="mainOutput"
      :selected="{}"
      :item="mainOutput"
      :vmode="3">
      </output-row>
      <div v-else class="label caption">
        No outputs.
      </div>

      <output-row
      v-for="output in secondaryOutputs" 
      :key="output.id"
      :selected="{}"
      :item="output"
      :vmode="3">
      </output-row>   
    </td>
    <td>
      <div :class="['text-ellipsed']">
      {{ dateEndFromNow }}
      </div>
      <div class="textSecondary--text caption">
        {{ dateEndFormatted }}
      </div>
    </td>
  </tr>
  -->
</template>

<script>
import OutputRow from '../stages/overview/output-row'
import TextHighlight from 'vue-text-highlight'
import JsonViewer from '@/components/toolbox/json-viewer/Main'

export default {
  props: ['item', 'itemsMeta', 'selected', 'searchFilters'],
  components: {
    OutputRow,
    TextHighlight,
    JsonViewer
  },
  computed: {
    timelineStage () {
      if (this.production.completed) {
        return 2
      } else if (this.production.date_start !== null) {
        return 1
      }
      return 0
    },
    production () {
      return this.item
    },
    outputs () {
      /* return Object.values(this.$store.state.db.productionOutputs.productionOutputs).filter(item => {
        return item.production_id === this.item.id
      }).sort((a, b) => {
        return b.quantity - a.quantity
      }) */
      return this.item.items.sort((a, b) => {
        return b.quantity - a.quantity
      })
    },
    mainOutput () {
      return this.outputs[0]
    },
    secondaryOutputs () {
      return this.outputs.slice(1)
    },
    dateStartFormatted () {
      if (this.$moment.utc(this.item.date_start).isValid()) {
        return this.$moment(this.item.date_start).format('ddd D, MMM YYYY, h:mm')
      }
      return ''
    },
    dateStartFromNow () {
      if (this.$moment.utc(this.item.date_start).isValid()) {
        return this.$moment.utc(this.item.date_start).fromNow()
      }
      return ''
    },
    dateEndFormatted () {
      if (this.$moment.utc(this.item.date_end).isValid()) {
        return this.$moment(this.item.date_end).format('ddd D, MMM YYYY, h:mm')
      }
      return ''
    },
    dateEndFromNow () {
      if (this.$moment.utc(this.item.date_end).isValid()) {
        return this.$moment.utc(this.item.date_end).fromNow()
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.selected-row::before {
  background: var(--v-color1-base);
  height: 100%;
  width: 100%;
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  opacity: 0.1;
}
</style>

